import { iseeInstance } from '../axiosService'

class GlassVUService {
  async fetchDevices (portalName) {
    return iseeInstance.get(`/devices/portal/${portalName}`)
  }

  async addDevice (glassName, portalName, users, licenceId) {
    return iseeInstance.post('/devices/', {
      name: glassName,
      portal: portalName,
      users,
      licenceId
    })
  }

  async getDevice (selectedDeviceId) {
    return iseeInstance.get('/devices/' + selectedDeviceId)
  }

  async editDevice (selectedDeviceId, glassName, users, portalName, licenceId) {
    return iseeInstance.put('/devices/' + selectedDeviceId, {
      name: glassName,
      users,
      portal: portalName,
      licenceId
    })
  }

  async removeDevice (glassToken) {
    return iseeInstance.delete('/devices/', { data: { token: glassToken } })
  }

  async releaseDevice (glassToken) {
    return iseeInstance.patch('/devices/release', { token: glassToken })
  }
}

export default new GlassVUService()
